export default __webpack_public_path__ + "static/media/image-drawer-regular.0256be18.png";